import React, { useEffect } from 'react';
import { signinCallback } from '@libs/oidc-client';
import useFilevineClient from '@hooks/Filevine/useFilevineClient';

const SigninCallback: React.FC = () => {
    const { onFVUserConnectSuccess } = useFilevineClient();

    useEffect(() => {
        signinCallback()
            .then(() => {
                onFVUserConnectSuccess();
            })
            .catch((error) => {
                console.error('Signin callback failed:', error);
            });
    }, [onFVUserConnectSuccess]);

    return <div>Signing you in...</div>;
};

export default SigninCallback;